import React from "react";import 
ProjStyle from "./ProjStyle.css";
import ReactDOM from 'react-dom';

const aboutStyle = {
    mx: 'auto',
    color: '#457b9d',
    marginBottom: '40px'
}

const Projects = props =>(
    <div> 
<section id="projects" style={{
        marginRight: '135px', marginLeft: '135px',
        marginTop: '40px', marginBottom: '40px', 
        }}>
    <h3 style={aboutStyle}>projects</h3>
<section>
    <ul id="projects">
<li id="projectlist">Super Peach Sisters</li>
<p> A game based on Super Mario that centers around Peach. 
This game was built in C++ for the course CS32 using polymorphism, STL, and inheritance.</p>

<li id="projectlist">UnHinged</li>
<p>A dating app inspired by ‘Hinged’. It utilizes a RadixTree to match users based on similar attributes. 
This program was built in C++ for the course CS 32 which includes a RadixTree and incorporates templates. </p>

<li id="projectlist">Final Grade Calculator</li>
<p>
A calculator built with JQuery, and Bootstrap5. It collects the grade and weighting percentages of an 
assignment and finds the final grade for all given inputs. A GPA calculator feature is currently in progress. 
</p>
</ul>
</section>
    </section>
    <hr></hr>
    </div>
)

export default Projects;